module.exports = __webpack_public_path__ + "img/category-detail-icon1.072686e4.svg";